import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import isWaitingForNetwork from 'store/app/selector/isWaitingForNetwork';
import styles from './WaitingForNetwork.module.scss';
import Spinner from '../Spinner/Spinner';

const WaitingForNetwork = () => {
  const showScreenBlocker = useSelector(isWaitingForNetwork);

  return (
    <div
      className={cn({
        [styles.waitingForNetwork]: true,
        [styles.visible]: showScreenBlocker,
      })}
    >
      {showScreenBlocker && (
        <div className={styles.spinner}>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default WaitingForNetwork;
